import React, { useState, useEffect } from "react";
import { Input, Button, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";

function EditCompanyOfficeStaff() {

  const { staff_id } = useParams();
  const navigate = useNavigate();

  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});

  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [staff_email, set_staff_email] = useState("");
  const [errorSecurity, setErrorSecurity] = useState("");
  const [role, set_role] = useState("");
  const userRole = localStorage.getItem("role");

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      set_errors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  const [phone_number, set_phone_number] = useState("");
  const [roles, set_roles] = useState([]);
  const [ships, set_ships] = useState([]);
const [selectedShips, set_selectedShips] = useState([]);

  const login_token = localStorage.getItem("login_token");
  const refresh_token = localStorage.getItem("refresh_token");



/* ---------------- GET STAFF DETAILS ---------------- */

  const VIEW_STAFF = () => {

    const FORM_DATA = new FormData();

    FORM_DATA.append("login_token", login_token);
    FORM_DATA.append("refresh_token", refresh_token);
    // FORM_DATA.append("staff_id", staff_id);
    FORM_DATA.append("staff_id", atob(staff_id));

    post(ApiURL.get_company_office_staff, FORM_DATA).then((res)=>{

        if(res?.status === true){

            const data = res?.staff_data;

            set_first_name(data?.first_name);
            set_last_name(data?.last_name);
            set_staff_email(data?.staff_email);
            set_phone_number(data?.phone_number);
            set_role(data?.role);

// if (data?.ship_ids) {

//   let ships = data.ship_ids;

//   if (typeof ships === "string") {
//     ships = ships.split(",");
//   }

//   if (Array.isArray(ships)) {
//     ships = ships.map((s) => (typeof s === "object" ? s.id : Number(s)));
//   }

//   set_selectedShips(ships);

// }
if (data?.ship_details) {
  const shipIds = data.ship_details.map((ship) => ship.id);
  set_selectedShips(shipIds);
}

        }

    });

  };


/* ---------------- GET ROLES ---------------- */

  const GET_ROLES = () => {

    const FORM_DATA = new FormData();

    FORM_DATA.append("login_token", login_token);
    FORM_DATA.append("refresh_token", refresh_token);

    post(ApiURL.list_office_roles, FORM_DATA).then((res)=>{

        if(res?.status === true){

            set_roles(res?.roles);

        }

    });

  };

  const SHIP_LIST_API = () => {

  const FORM_DATA = new FormData();

  post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {

    if (res?.status) {
      set_ships(res?.ships || []);
    } else {
      ErrorToast("Error", res?.message);
    }

  });

};

/* ---------------- UPDATE STAFF ---------------- */

  const UPDATE_STAFF = () => {

    set_loader(true);

    const FORM_DATA = new FormData();

    FORM_DATA.append("login_token", login_token);
    FORM_DATA.append("refresh_token", refresh_token);
    // FORM_DATA.append("staff_id", staff_id);
    FORM_DATA.append("staff_id", atob(staff_id));

    FORM_DATA.append("name", first_name + " " + last_name);
    FORM_DATA.append("phone_number", phone_number);
    FORM_DATA.append("role", role);
    FORM_DATA.append("ship_ids", selectedShips.join(","));

    post(ApiURL.edit_company_office_staff, FORM_DATA).then((res)=>{

        set_loader(false);

        if(res?.status === true){

            SuccessToast("Success", res?.message);

            navigate("/company-staff");

        }else{

            set_errors(res?.errors || {});
            ErrorToast("Error", res?.message);

        }

    });

  };


/* ---------------- LOAD DATA ---------------- */

useEffect(()=>{

    GET_ROLES();
    VIEW_STAFF();
    SHIP_LIST_API();

},[]);



/* ---------------- UI ---------------- */

return(

<div className="white-container">

<h3>Edit Company Staff</h3>


<div className="row">

<div className="col-6">
<div className="input-box">

<label>First Name</label>

<Input
value={first_name}
onChange={(e)=>{
  set_first_name(e.target.value);
  clearError("name");
  clearError("first_name");
}}
/>
{errors?.first_name && <span style={{ color: "red" }}>{errors.first_name}</span>}
{errors?.name && <span style={{ color: "red" }}>{errors.name}</span>}

</div>
</div>


<div className="col-6">
<div className="input-box">

<label>Last Name</label>

<Input
value={last_name}
onChange={(e)=>{
  set_last_name(e.target.value);
  clearError("last_name");
}}
/>
{errors?.last_name && <span style={{ color: "red" }}>{errors.last_name}</span>}

</div>
</div>

</div>


<div className="row">

<div className="col-6">
<div className="input-box">

<label>Email</label>

<Input
value={staff_email}
disabled
/>

</div>
</div>


<div className="col-6">
<div className="input-box">

<label>Phone Number</label>

<Input
maxLength={10}
value={phone_number}
onChange={(e)=>{
  const formattedValue = e.target.value.replace(/\D/g, "");
  set_phone_number(formattedValue);
  clearError("phone_number");
}}
/>
{errors?.phone_number && <span style={{ color: "red" }}>{errors.phone_number}</span>}

</div>
</div>

</div>



{/* <div className="row">

<div className="col-6">
<div className="input-box">

<label>Role</label>

<Select
value={role}
style={{width:"100%"}}
onChange={(value)=>set_role(value)}
>

{roles.map((item)=>(
<Select.Option value={item.value}>
{item.label}
</Select.Option>
))}

</Select>

</div>
</div>

</div> */}

<div className="row">

  <div className="col-6">
    <div className="input-box">
      <label>Role</label>

      <Select
        value={role}
        style={{width:"100%"}}
        onChange={(value)=>{
          set_role(value);
          clearError("role");
        }}
      >
        {roles.map((item)=>(
          <Select.Option key={item.value} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>

    </div>
  </div>

  <div className="col-6">
    <div className="input-box">
      <label>Ships</label>

      <Select
        mode="multiple"
        showSearch
        optionFilterProp="children"
        value={selectedShips}
        placeholder="Select Ships"
        style={{ width: "100%" }}
        onChange={(value)=>{
          set_selectedShips(value);
          clearError("ship_ids");
        }}
      >
        {ships.map((ship)=>(
          <Select.Option key={ship.id} value={ship.id}>
            {ship.vessel_name}
          </Select.Option>
        ))}
      </Select>

    </div>
  </div>

</div>


<br/>

<Button
type="primary"
loading={loader}
onClick={UPDATE_STAFF}
>

Update

</Button>


</div>

);

}

export default EditCompanyOfficeStaff;